import apiClient from "./interceptor"

export const getTrendsData= async (secureCode) => {
    try {
        const response = apiClient.get(`/v1/analytics/therapy/secureCode-scan-report`);
        return response;
    } catch (err) {
        console.log(err);
        return err;
    }
}